import { useTranslation } from "react-i18next";
import { SlidersHorizontal, ArrowUpDown } from "lucide-react";

const InputBox = ({ setFilterOpen, sort, handleSortChange }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-row items-start justify-end w-full gap-3 px-6 mt-4 sm:items-center">
      {/* Tombol Filter */}
      <button
        onClick={setFilterOpen}
        className="flex items-center gap-2 px-5 py-2.5 border border-[#f5272b] text-[#f5272b] font-semibold rounded-md hover:bg-[#f5272b] hover:text-white transition-all duration-300"
      >
        <SlidersHorizontal className="w-4 h-4" />
        <span>{t("open_filters")}</span>
      </button>

      <div className="relative w-60">
        <select
          value={sort}
          onChange={(e) => handleSortChange(e.target.value)}
          className="w-full px-4 py-2.5 bg-white border border-gray-300 rounded-md text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#f5272b] appearance-none cursor-pointer transition-all duration-200"
        >
          <option value="" disabled>
            {t("sort")}
          </option>
          <option value="priceAsc">{t("price_low_to_high")}</option>
          <option value="priceDesc">{t("price_high_to_low")}</option>
          <option value="nameAsc">{t("name_a_z")}</option>
          <option value="nameDesc">{t("name_z_a")}</option>
        </select>
        <ArrowUpDown className="absolute right-3 top-3.5 w-4 h-4 text-gray-400 pointer-events-none" />
      </div>
    </div>
  );
};

export default InputBox;
